(function () {
  var items = document.querySelectorAll('.custom-timeline__item');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (item) {
      item.classList.add('tl-visible');
    });
    return;
  }

  // Full animation duration: text delay (0.35s) + text fade (0.6s) = 950ms
  var ANIMATION_DURATION = 450;
  var queue = [];
  var animating = false;

  function processQueue() {
    if (queue.length === 0) {
      animating = false;
      return;
    }
    animating = true;
    var item = queue.shift();
    item.classList.add('tl-visible');
    setTimeout(processQueue, ANIMATION_DURATION);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          queue.push(entry.target);
          observer.unobserve(entry.target);
          if (!animating) {
            processQueue();
          }
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
  );

  items.forEach(function (item) {
    observer.observe(item);
  });
})();
